<template>
  <div>
    <el-select
      name="applications"
      placeholder="Select"
      multiple
      collapse-tags
      v-model="selectedValues"
      value-key="value"
      class="application-select"
      :class="{'application-select-multi' : selectedValues.length > 1}"
    >
      <el-option-group
        v-if="this.$store.state.applicationTemplateIds.length > 0"
        :label="'Select Application(s) for overview data'"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'application-template-multi-select',
  props: {
    defaultSelected: {
      type: Array,
      default() { return []}
    }
  },
  data () {
    return {
      selectedValues: [],
      options: []
    }
  },
  mounted() {
    this.constructOptions()
    this.onMount()
  },
  methods: {
    onMount() {
      if(this.defaultSelected.length > 0) {
        this.selectedValues = this.defaultSelected
        this.$store.state.selectedApplicationTemplateIds = this.defaultSelected
      }
    },
    constructOptions() {
      const templates = this.$store.state.applicationTemplateIds
      if(templates.length > 0) {
        this.options = templates.map((template) => {
          return {
            value: template.id,
            label: template.name
          }
        })
      }
    }
  },
  watch: {
    selectedValues() {
      // check needed if no options are selected, which would default to verification view
      this.$store.state.selectedApplicationTemplateIds = this.selectedValues.length === 0
        // fake template id provided to prevent fetching for verification analytics while in applicatiuon view
        ? [999999999.9999]
        : this.selectedValues

    }
  }

}
</script>

<style lang="scss" scoped>
.application-select {
  width: 250px;
}
</style>
